import Addresses from './components/Addresses';
export default Addresses;